// extracted by mini-css-extract-plugin
export default {"CardBodyHeader":"style_CardBodyHeader__9g2wS","CardItem":"style_CardItem__UWHvH"};